<template>
  <div class="map-container" @click="handleMapClick">
    <!-- 动态标点渲染 -->
    <div
      v-for="(item, index) in areaData"
      :key="index"
      class="point-wrapper"
      :style="{ left: item.x + 'rem', top: item.y + '%' }"
      @click.stop="selectPoint(index, true)"
    >
      <div class="point-dot"></div>
      <div class="point-label">
        <span class="total-tag">{{ item.deviceAllCount }}</span>
        <span class="name-tag">{{ item.areaName }}</span>
      </div>
    </div>

    <!-- 弹窗组件 -->
    <transition name="fade">
      <div
        v-if="activeIndex !== null && areaData.length > 0"
        class="info_popup"
        :style="{
          left: areaData[activeIndex].x + 1.65 + 'rem',
          top: areaData[activeIndex].y - 1.5 + '%'
        }"
        @click.stop
      >
        <div class="popup_header">
          <span>{{ areaData[activeIndex].areaName }}</span>
          <img
            src="./close.png"
            class="close-btn"
            @click="
              activeIndex = null
              startRotation()
            "
          />
        </div>
        <div class="popup_content">
          <ul class="deviceInfo">
            <li class="item">
              <div class="item_left">
                <img src="./device.png" />
              </div>
              <div class="item_right">
                <span class="item_num">{{ areaData[activeIndex].deviceAllCount }}<em>台</em></span>
                <span class="item_name">设备总数</span>
              </div>
            </li>
            <li class="item">
              <span class="item_num">{{ areaData[activeIndex].manual }}<em>台</em></span>
              <span class="item_name">手动设备</span>
            </li>
            <li class="item">
              <span class="item_num">{{ areaData[activeIndex].auto }}<em>台</em></span>
              <span class="item_name">自动设备</span>
            </li>
          </ul>
          <section class="statisInfo">
            <div class="statisInfo_title">
              <img src="./add.png" />
              <span>报备信息统计</span>
            </div>
            <ul class="statis_list">
              <li>
                <span class="mark"></span>
                <span class="num"
                  >报备 <em>{{ areaData[activeIndex].deal }}</em
                  >次</span
                >
              </li>
              <li>
                <span class="mark"></span>
                <span class="num"
                  >未报备 <em>{{ areaData[activeIndex].noDeal }}</em
                  >次</span
                >
              </li>
              <li>
                <span class="mark"></span>
                <span class="num"
                  >报备率 <em>{{ areaData[activeIndex].rate }}</em
                  >%</span
                >
              </li>
            </ul>
          </section>
          <img class="popup-arrow" src="./arrow.png" @click="openNextData" />
        </div>
        <img class="popup_line" src="./line.png" />
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: 0, // 当前激活的点位索引
        timer: null, // 轮播定时器
        refreshTimer: null, // 轮播间隔时间
        points: [
          {
            name: '梅山街道',
            x: 1.99,
            y: 76
          },
          {
            name: '板桥街道',
            x: 2.75,
            y: 54
          },
          {
            name: '古雄街道',
            x: 3.25,
            y: 60
          },
          {
            name: '雨花街道',
            x: 7.21,
            y: 17
          },
          {
            name: '西善桥街道',
            x: 4.78,
            y: 46
          },
          {
            name: '铁心桥街道',
            x: 6.02,
            y: 52
          },
          {
            name: '赛虹桥街道',
            x: 6.95,
            y: 8.1
          },
          {
            name: '开发区',
            x: 2.95,
            y: 41
          },
          {
            name: '软件谷',
            x: 6.22,
            y: 30
          }
        ],
        areaData: [] // 用于存储合并后的数据
      }
    },
    mounted() {
      this.getData()
      this.startRefreshTimer()
    },
    beforeDestroy() {
      this.stopRotation()
      this.stopRefreshTimer() // 清理数据刷新定时器
    },
    methods: {
      getData() {
        const dataRes = this.$axiosget('operation/automatic/hand/detection/getAreaData')
        const dictRes = this.$axiosget('operation/dictionaryType/queryByKey', {
          params: {
            key: 'districtType'
          }
        })

        Promise.all([dataRes, dictRes]).then(res => {
          if (res[0].data.status == 10000 && res[1].data.status == 10000) {
            // 使用 reduce 创建 pointsMap
            const pointsMap = this.points.reduce((map, point) => {
              map[point.name] = { x: point.x, y: point.y }
              return map
            }, {})

            // 创建 list 并使用 Map 提高查找效率
            const listMap = new Map()
            res[1].data.data.list.forEach(item => {
              const pointData = pointsMap[item.name]
              if (pointData) {
                listMap.set(Number(item.value), {
                  id: Number(item.value),
                  x: pointData.x,
                  y: pointData.y,
                  name: item.name
                })
              }
            })

            // 过滤并合并数据，直接使用 listMap 获取坐标信息
            this.areaData = res[0].data.data
              .filter(item => listMap.has(item.area.id))
              .map(item => {
                const pointData = listMap.get(item.area.id)
                return {
                  ...item,
                  x: pointData.x,
                  y: pointData.y,
                  name: pointData.name,
                  areaName: item.area.name
                }
              })
            // this.startRotation()
          }
        })
      },
      // 启动数据刷新定时器
      startRefreshTimer() {
        this.stopRefreshTimer() // 先清除可能存在的定时器
        this.refreshTimer = setInterval(() => {
          this.getData()
        }, 5 * 60 * 1000) // 5分钟 = 300000毫秒
      },
      // 停止数据刷新定时器
      stopRefreshTimer() {
        if (this.refreshTimer) {
          clearInterval(this.refreshTimer)
          this.refreshTimer = null
        }
      },
      // 开启自动轮播
      startRotation() {
        this.stopRotation()
        this.timer = setInterval(() => {
          this.next()
        }, 3000) // 3秒切换一次
      },
      // 停止轮播
      stopRotation() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      },
      // 切换下一个
      next() {
        this.activeIndex = (this.activeIndex + 1) % this.areaData.length
      },
      // 手动选中点位
      selectPoint(index, isManual) {
        this.activeIndex = index
        if (isManual) {
          // 如果是手动点击，停止轮播
          this.stopRotation()
        }
      },
      // 点击地图空白处重新开始轮播
      handleMapClick() {
        this.startRotation()
      },
      openNextData() {
        let data = this.areaData[this.activeIndex]
        this.$emit('openNextData', data)
      }
    }
  }
</script>

<style lang="less" scoped>
  .map-container {
    position: absolute;
    top: 25.79vh;
    left: 5.17rem;
    width: 8.73rem;
    height: 54.72vh;
    background: url('./map.png') no-repeat;
    background-size: 100% 100%;
  }

  /* 点位容器 */
  .point-wrapper {
    position: absolute;
    cursor: pointer;
    z-index: 10;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
  }

  /* 呼吸灯效果 */
  .point-dot {
    width: 0.19rem;
    height: 1.76vh;
    background: #ffc35b;
    border-radius: 50%;
    border: 0.37vh solid #fff;
  }

  /* 标签样式 */
  .point-label {
    position: absolute;
    top: -1.21vh;
    left: -1.37rem;
    width: 1.41rem;
    height: 2.23vh;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: url('./name_bg.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    padding-right: 0.17rem;
  }

  .total-tag {
    display: inline-block;
    min-width: 0.34rem;
    height: 1.3vh;
    background-color: #ffc35b;
    border-radius: 0.07rem;
    padding: 0 0.07rem;
    text-align: center;
    line-height: 1.3vh;
    font-family: SourceHanSansCN-Light;
    font-size: 1.11vh;
    color: #fff;
    margin-right: 0.02rem;
  }

  .name-tag {
    font-size: 1.3vh;
    font-family: MicrosoftYaHei;
    color: #fff;
  }

  /* 弹窗样式 */
  .info_popup {
    position: absolute;
    z-index: 100;
    width: 3.72rem;
    height: 21.33vh;
    background: url('./popup.png') no-repeat;
    background-size: 100% 100%;
    transform: translate(0.2rem, -23%); /* 弹窗显示在点位的右上角 */

    .popup_header {
      height: 3.99vh;
      background: url('./header_bg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.13rem 0 0.22rem;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      font-size: 1.67vh;
      color: #fff;

      img {
        width: 0.13rem;
        height: auto;
        cursor: pointer;
      }
    }

    .popup_content {
      height: 17.34vh;
      padding: 0 0.19rem;
      position: relative;

      .deviceInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.67vh 0.21rem 1.48vh 0.05rem;

        li {
          height: 0.53rem;
          position: relative;

          &:first-child {
            display: flex;
            align-items: center;

            .item_left {
              width: 0.58rem;
              font-size: 0;

              img {
                width: 100%;
                height: auto;
              }
            }

            .item_right {
              margin-left: 0.13rem;
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            .item_num {
              color: #29f4ff;
            }
          }

          &:not(:first-child) {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 0.37vh;

            &::after {
              content: '';
              position: absolute;
              left: -0.2rem;
              top: 50%;
              transform: translateY(-50%);
              width: 1px;
              height: 100%;
              background: #296ac5;
            }
          }

          .item_num {
            font-family: MicrosoftYaHei;
            font-weight: bold;
            font-size: 1.86vh;
            color: #4fb3ff;

            em {
              margin-left: 0.03rem;
              font-size: 1.11vh;
              font-weight: normal;
              color: rgba(255, 255, 255, 0.6);
            }
          }

          .item_name {
            font-family: MicrosoftYaHei;
            font-size: 1.11vh;
            color: #fff;
          }

          &:last-child .item_num {
            color: #ffc52a;
          }
        }
      }

      .statisInfo {
        height: 5.75vh;
        background: url('./info_bg.png') no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 0.09rem;

        &_title {
          display: flex;
          align-items: center;
          font-family: MicrosoftYaHei;
          font-size: 1.3vh;
          color: #ffffff;

          img {
            width: 0.11rem;
            height: auto;
            margin-right: 0.02rem;
          }
        }

        .statis_list {
          display: flex;
          justify-content: space-between;
          align-items: center;

          li {
            display: flex;
            align-items: center;

            .mark {
              width: 0.06rem;
              height: 0.56vh;
              background-color: #29f4ff;
              display: inline-block;
              margin-right: 0.05rem;
              margin-top: 0.56vh;
            }

            .num {
              font-family: MicrosoftYaHei;
              font-size: 1.11vh;
              color: #ffffff;

              em {
                margin-left: 0.02rem;
                font-family: MicrosoftYaHei;
                font-weight: bold;
                font-size: 1.48vh;
                color: #29f4ff;
              }
            }

            &:nth-child(2) {
              .mark {
                background-color: #ff4949;
              }

              .num em {
                color: #ff4949;
              }
            }

            &:nth-child(3) {
              .mark {
                background-color: #3cafff;
              }

              .num em {
                color: #3cafff;
              }
            }
          }
        }
      }

      .popup-arrow {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        cursor: pointer;
        width: 0.53rem;
        height: 1.3vh;
      }
    }

    .popup_line {
      position: absolute;
      top: 1.4vh;
      left: -1.86rem;
      width: 1.86rem;
      height: 4.35vh;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/pmap/index.vue